import {getHeaders} from './utils';

export const GetNotes = (token: string, meeting: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${meeting}`);
		}
	});
};

export const GetAllNotes = (token: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/all`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes`);
		}
	});
};

export const CreateNote = (token: string, meeting: number, fromGlobal?: boolean) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/create`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({
			meeting,
		}),
	}).then(async result => {
		if (result.ok) {
			const results = await result.json();
			return [results, fromGlobal];
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/save could not save`);
		}
	});
};


export const SaveNote = (token: string, meeting: number, title: string, content: string, content_text: string, shared_with: string | null, id?: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/save`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify({
			id,
			meeting,
			title,
			content,
			content_text,
			shared_with,
		}),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/save could not save`);
		}
	});
};

export const DeleteNote = (token: string, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`, {
		method: 'DELETE',
		headers: getHeaders(token) as any,
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`);
		}
	});
};

export const UndeleteNote = (token: string, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`);
		}
	});
};

export const AddToMeeting = (token: string, meeting: number, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}/${meeting}`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
	}).then(result => {
		return { id, meeting };
	});
};

export const RemoveFromToMeeting = (token: string, meeting: number, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}/${meeting}`, {
		method: 'DELETE',
		headers: getHeaders(token) as any,
	}).then(result => {
		return { id, meeting };
	});
};
